// One order of aldoo.com: the framework's order page (aldoo-ra/StoreOrders)
// over aldoo.com's orders API, in the vendor portal's words, with the pickup
// office on the courier's map.
import React from "react"
import FrameworkOrderPage from "aldoo-ra/StoreOrders/OrderPage"
import { ORDERS_API, useOrderTexts, useOrderLocale, renderPickup, renderQR, renderShip, renderShipment, extraPrints } from "./orders-setup"

export default function OrderPage(props) {
  const locale = useOrderLocale()
  return <FrameworkOrderPage api={ORDERS_API} useTexts={useOrderTexts} locale={locale} renderPickup={renderPickup} renderQR={renderQR} renderShip={renderShip} renderShipment={renderShipment} extraPrints={extraPrints} {...props} />
}
